import { CheckCircleIcon, XCircleIcon } from "@heroicons/react/24/outline";
import { Link } from "react-router-dom";
import {
  renderCustomColumnDefs,
  renderValidations,
} from "../../shared/Table/table.utils";
import { statusOptions } from "../../constants/select";
import { formatDate, isNum, renderAmount } from "../../utils";
import { Badge } from "../../shared";
import { hasStoredPermission } from "../../utils/authority";
import { PERMISSIONS } from "../../constants/access-control";

// Config for table and form
const tableConfig = [
  {
    id: "manifestId",
    visible: true,
    header: "Manifest id",
    cell: ({ row: { original }, getValue }) => {
      return (
        <Link
          className="text-primary-600 hover:underline"
          to={`/manifests/${original._id}`}
        >
          {getValue()}
        </Link>
      );
    },
  },
  {
    id: "status",
    editable: {
      type: "select",
      options: statusOptions,
    },
    cell: ({ getValue }) => getValue(),
  },
  {
    id: "dateCreated",
    cell: ({ getValue }) => {
      return formatDate(getValue(), null, true);
    },
  },
  {
    id: "driver",
    // header: "Driver",
    cell: ({ getValue, row: { original } }) => {
      const value = getValue();
      if (!value) return;
      return value.length > 1
        ? original.organization?.name
        : value.fullName || value.firstName;
    },
  },
  {
    Header: "# of Drops",
    id: "legs",
    cell: ({ getValue }) => getValue().length,
  },
  {
    header: "Payout",
    id: "payoutId",
    minWidth: 200,
    cell: ({ getValue }) => {
      if (getValue()) {
        return (
          <Badge
            link={`/payouts/${getValue()._id}`}
            label={`Payout ${getValue().payoutId}`}
          ></Badge>
        );
      }
      return null;
    },
    visible: true,
    remove: !hasStoredPermission(PERMISSIONS.PAYOUTS_READ),
  },

  // {
  //   id: "active",
  //   cell: ({ row: { original }, value }) => {
  //     return value ? (
  //       <CheckCircleIcon className="w-5 h-5 text-green-500" />
  //     ) : (
  //       <XCircleIcon className="w-5 h-5 text-red-500" />
  //     );
  //   },
  // },
];

export const COLUMN_DEFINITIONS = renderCustomColumnDefs(tableConfig);
export const FORM_OPTIONS = { validations: renderValidations(tableConfig) };
export const PAGE_SIZE_OPTIONS = [
  { label: "10 Jobs", value: 10 },
  { label: "20 Jobs", value: 20 },
  { label: "50 Jobs", value: 50 },
  { label: "100 Jobs", value: 100 },
  { label: "150 Jobs", value: 150 },
];
